var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9708 2.56986C12.6058 2.20498 12.1108 2 11.5947 2C11.0786 2 10.5837 2.20498 10.2187 2.56986L9.75998 3.0292L12.9714 6.24067L13.4295 5.78198C13.6103 5.60124 13.7537 5.38667 13.8515 5.1505C13.9493 4.91434 13.9997 4.66122 13.9997 4.40559C13.9997 4.14997 13.9493 3.89685 13.8515 3.66068C13.7537 3.42452 13.6103 3.20994 13.4295 3.0292L12.9708 2.56986ZM12.0534 7.15805L8.84195 3.94658L2.94452 9.84466C2.81547 9.97373 2.72531 10.1365 2.68436 10.3144L2.01676 13.2047C1.99189 13.312 1.99474 13.4239 2.02505 13.5298C2.05536 13.6357 2.11214 13.7321 2.19002 13.81C2.26791 13.8879 2.36434 13.9446 2.47024 13.9749C2.57613 14.0053 2.688 14.0081 2.7953 13.9832L5.68627 13.3163C5.86391 13.2752 6.02644 13.1851 6.15534 13.0561L12.0534 7.15805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil16);
export default __webpack_public_path__ + "static/media/Pencil16.c5222c017b84bf7f7b98e67f9300768d.svg";
export { ForwardRef as ReactComponent };